import { render, staticRenderFns } from "./TipoPagos.view.vue?vue&type=template&id=b2e7b0c2&"
import script from "./TipoPagos.view.vue?vue&type=script&lang=js&"
export * from "./TipoPagos.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports